/**
 * Welcome to ToolbarBuilderConfig
 * Max steps to implement new Toolbar: 3
 */

import KEYWORDS from '../keywords';

/**
 * Step 1: Import custom toolbar
 */
import { PhotoReportToolbar } from 'core/ElementViewBuilder/views/PhotoReportViewer/Toolbar';
import { TenantsToolbar } from 'core/modules/Tenants';
const { ROUTES } = KEYWORDS;

/**
 * Step 2: Add custom toolbar keys
 */
const authorizedToolbarKeys = {
	SUPERVISOR_ELEMENT: `${ROUTES.FEED.PATH}/supervisor/:elementId`,
	// <--HERE
};

const authorizedFullToolbarKeys = {
	TENANTS: ROUTES.FEED_TENANTS.PATH,
};

/**
 * Step 3: Add custom toolbar key value pairs
 */
const authorizedToolbarComponents = {
	[authorizedToolbarKeys.SUPERVISOR_ELEMENT]: PhotoReportToolbar,
	// <--HERE
};

const authorizedFullToolbarComponents = {
	[authorizedFullToolbarKeys.TENANTS]: TenantsToolbar,
};

export default class ToolbarBuilderConfig {
	static getAuthorizedToolbarReactNodes() {
		return authorizedToolbarComponents;
	}

	static getAuthorizedFullToolbarReactNodes() {
		return authorizedFullToolbarComponents;
	}
}
